import { useEffect, useState } from 'react'
import { getRandomVerb, VERB_ROTATION_INTERVAL_MS } from './thinkingVerbs'

export default function ThinkingIndicator() {
    const [currentVerb, setCurrentVerb] = useState(getRandomVerb)
    const [isTransitioning, setIsTransitioning] = useState(false)

    useEffect(() => {
        const interval = setInterval(() => {
            setIsTransitioning(true)
            setTimeout(() => {
                setCurrentVerb(getRandomVerb())
                setIsTransitioning(false)
            }, 150)
        }, VERB_ROTATION_INTERVAL_MS)
        return () => clearInterval(interval)
    }, [])

    return (
        <div className="flex items-center gap-3">
            <span className="inline-flex h-4 w-4 animate-spin rounded-full border-2 border-primary-600 border-t-transparent" />
            <span
                className={`text-sm text-gray-500 transition-opacity duration-150 ${
                    isTransitioning ? 'opacity-0' : 'opacity-100'
                }`}
            >
                {currentVerb}...
            </span>
        </div>
    )
}
